import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'

import { PropertyRow } from '../../../theme/components/PropertyRow'
import type { HoofdleidingProject } from '../../project/types/HoofdleidingProject'
import { planningProcesstapDict } from '../util/planning-util'

export { ProjectStatusTiles }

type Props = {
  projecten: HoofdleidingProject[]
  total: number
  limit: number
  selected: string[]
  onChangeSelected: (selected: string[]) => void
}

const ProjectStatusTiles = ({
  projecten,
  total,
  limit,
  selected,
  onChangeSelected,
}: Props) => {
  const toggle = (processtap: string) =>
    onChangeSelected(
      selected.includes(processtap)
        ? selected.filter((p) => p !== processtap)
        : [...selected, processtap],
    )

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'start',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'start', flexGrow: 1 }}>
        {planningProcesstapDict.map(({ label, color }) => {
          const count = projecten.filter(
            ({ statusText }) => statusText === label,
          ).length
          const isSelected = selected.includes(label)

          return (
            <ButtonBase
              key={label}
              aria-pressed={isSelected}
              onClick={() => toggle(label)}
              sx={{
                display: 'block',
                textAlign: 'left',
                borderLeft: `4px solid ${color}`,
                paddingLeft: 2,
                width: '100%',
                maxWidth: '200px',
                ...(isSelected && {
                  bgcolor: color,
                  '& .MuiTypography-root': { color: 'common.white' },
                }),
              }}
            >
              <PropertyRow label={label} value={count} variant="h5" />
            </ButtonBase>
          )
        })}
      </Box>

      <Box
        sx={{
          borderRight: '4px solid',
          borderColor: 'primary.main',
          paddingRight: 2,
          textAlign: 'right',
        }}
      >
        <PropertyRow
          label="Resultaten"
          value={total === -1 ? `${limit}+` : total}
          variant="h5"
        />
      </Box>
    </Box>
  )
}
